import styled from 'styled-components'

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    flex-wrap:wrap;
    justify-content:space-around;

    @media (max-width: 768px) {
    display: grid;
    width: 500px;
  }
`
export const UserSoldContainer = styled.div`

    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top:40px;

`
export const UserSoldLeftContainer = styled.div`
    border: 3px solid #7e7d7a;


    display: flex;
    flex-direction: column;
    margin-right:50px;
    width:25%;
    height:60%;
    border-radius: 15px;

    i{
            margin:8px 8px;
            font-size:40px;

        }
`
export const PerfilPictureContainer = styled.div`

    .perfil-picture-background{
            border-radius: 50%;
            border:6px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 251px;
            height: 251px;
            margin: 20px 50px;
    }

        img{
            width: 244px;
            height: 244px;
            border-radius:50%;
            }

`
export const UserSoldFeatureContainerBotton = styled.div`

    display:flex;
    align-items:flex-start;
    flex-direction:column;
    margin:30px;


`
export const PerfilNameSinceContainer = styled.div`

    .user-name-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #002666;
            font-weight:bold;
    }

    .user-since-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color:#535353;
            font-weight:bold;
            font-size:12px;

    }

`
export const MySellerContainer = styled.div`

        margin-top:10px;

    .my-seller{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;
    }


    .my-seller-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;
    }
`
export const MyPurchaseContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;


`
export const PaymentContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ConfigurationContainer = styled.div`


    .configuration{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .configuration-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;

    }
`


// >>>>>>>>>>>CONTAINER DIREITO<<<<<<<<<<


export const UserSoldRightContainer = styled.div`
    border: 3px solid #7e7d7a;
    padding:40px;
    width:75%;
    height:500px;

    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius:15px;
`
export const UserSecurityTitle = styled.div`

    display: flex;
    flex-direction:row;
    align-items: flex-end;
    color: #002666;

    font-size: 26px;


    i{
        font-size:60px;
        margin-right: 20px;
    }

`
export const MsgFunctionality = styled.div`

    border-top: 3px solid #7e7d7a;
    margin-top:14px;
    padding: 35px 0;
    font-weight:bold;
    font-size: 20px;
    color: black;
`
export const UserSecuritySettingsContainer = styled.div`



  .user-status-config-row{
    margin:20px 0;
    display: flex;
    flex-direction:row;
    align-items: center;

  }



  .container-left{
    display: flex;

    i{
        font-size: 50px;
        color: #002666;

    }


  }
  .container-right{
    display: flex;
    flex-direction:column;
    margin-left:10px;

    p{
        font-weight:bold;
        font-size: 20px;
        margin:0;
    }

    span{
        font-size: 20px;

    }


  }

`
// >>>>>>>>>>>>>>>>>>>Container Botton<<<<<<<<<<<<<<<<<
export const Foote = styled.div`
 @media (max-width: 768px) {
    position: relative;
    top: 165px;
    }
`;

export const UserSoldContainerBot = styled.div`
    border: 3px solid #7e7d7a;
    display: flex;
    flex-direction:row;
    border-radius:15px;
    top: 50px;
    position: relative;
    margin: 0 -46px;
    padding: 6px;

    div{
        display: flex;
        flex-direction:column;
        padding:0 6px;
    }
    .verification-mode{

    }
    .msg-status{
        display: flex;
        flex-direction:row;
    }
    i{
        font-size:60px;
        margin:5px 1px 5px 46px;
        color: black;

    }

`